
import React from 'react';
import AdminLayout from '@/components/admin/AdminLayout';

const TemplateFormPage: React.FC = () => {
  return (
    <AdminLayout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Template Form</h1>
        <p className="mt-4">Create or edit certificate templates.</p>
      </div>
    </AdminLayout>
  );
};

export default TemplateFormPage;
